export default "__VITE_ASSET__DSHhtV$g__ 100w";